































import ResponsiveImage from '@/components/common/Image.vue';
import CampaignsQuery from '@/graphql/queries/campaigns.gql';
import request from '@/graphql/request';
import Vue from 'vue';
import Component from 'vue-class-component';

interface ICampaign {
  id: string;
  name: string;
  goal: number;
  raised: number;
  endDateTime: Date;
  thumbnail?: {
    url: string;
  };
}

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class Blog extends Vue {
  public posts: ICampaign[] = [];

  public mounted() {
    request(CampaignsQuery)
      .then(response => {
        if (!response || !response.data) {
          console.error('No posts returned');
          return;
        }

        this.posts = response.data.campaigns;
        this.posts.sort(
          (a, b) => +new Date(b.endDateTime) - +new Date(a.endDateTime)
        );
      })
      .catch(console.error);
  }

  public formatDate(date: Date | string) {
    return new Date(date).toLocaleDateString(undefined, {
      day: '2-digit',
      year: 'numeric',
      month: 'long',
    });
  }

  public backgroundColor(id: string) {
    const seed = id.substr(id.lastIndexOf('-') + 1);
    const color = (n: number) => parseInt(seed.substr(n, 2), 16);
    const darken = (n: number) =>
      ((c: number) => (c - 60 >= 0 ? c - 60 : c))(color(n));

    return `linear-gradient(to bottom, rgb(${color(0)}, ${color(2)}, ${color(
      4
    )}), rgb(${darken(0)}, ${darken(2)}, ${darken(4)})`;
  }
}
